const RangeDownloads = {
  parts: ['container'],
  baseStyle: {
    container: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: {base: 'column', md: 'row'},
      gap: {base: 2.5, md: 4},
      justifyContent: 'center',
      paddingBottom: {base: 16, md: 30},
      paddingTop: {base: 0, md: 14},
      paddingX: {base: 5, md: 0},
    },
  },
  variants: {
    default: {},
  },
  defaultProps: {
    variant: 'default',
  },
};

export default RangeDownloads;
